"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unlockPageScroll = exports.lockPageScroll = void 0;
require("core-js/modules/es.object.assign.js");
/**
 * Enable or disable the users ability to scroll on the page
 */
var lockPageScroll = exports.lockPageScroll = function lockPageScroll() {
  var rootEl = document.querySelector('html');
  var bodyEl = document.querySelector('body');
  if (rootEl && bodyEl) {
    var styles = {
      overflow: 'hidden',
      position: 'relative'
    };
    Object.assign(rootEl.style, styles);
    Object.assign(bodyEl.style, styles);
  }
};
var unlockPageScroll = exports.unlockPageScroll = function unlockPageScroll() {
  var rootEl = document.querySelector('html');
  var bodyEl = document.querySelector('body');
  if (rootEl && bodyEl) {
    rootEl.removeAttribute('style');
    bodyEl.removeAttribute('style');
  }
};